export interface LightBoardModel {
    id: string;
    location: string;
    operatingMode: OperatingModeType;
    currentMessage: string | null;
    sign: string | null;
}

export interface LightBoardSendMessageModel {
    message: string;
    sign: string | null;
}

export enum OperatingModeType {
    AUTO = "AUTO",
    MANUAL = "MANUAL"
}

export enum ManualOperatingSignCode {
    LEFT_TURN = "LEFT_TURN",
    RIGHT_TURN = "RIGHT_TURN",
    AHEAD = "AHEAD",
    NO_ENTRY = "NO_ENTRY"
}